/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useMutation } from 'react-query';
import type { MutationFunction, UseMutationOptions } from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { BEResponseWorkflowResponse, WorkflowEvent } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * variazioneSoggettoBeneficiario
 * @summary variazioneSoggettoBeneficiario
 */
export const postBackAzioniRnaVariazioneSoggettoBeneficiario = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/variazioneSoggettoBeneficiario`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaVariazioneSoggettoBeneficiarioMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postBackAzioniRnaVariazioneSoggettoBeneficiario>
      >,
      TError,
      { data: WorkflowEvent },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaVariazioneSoggettoBeneficiario>>,
    TError,
    { data: WorkflowEvent },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postBackAzioniRnaVariazioneSoggettoBeneficiario>
      >,
      { data: WorkflowEvent }
    > = props => {
      const { data } = props ?? {};

      return postBackAzioniRnaVariazioneSoggettoBeneficiario(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostBackAzioniRnaVariazioneSoggettoBeneficiarioMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniRnaVariazioneSoggettoBeneficiario>>
  >;
export type PostBackAzioniRnaVariazioneSoggettoBeneficiarioMutationBody =
  WorkflowEvent;
export type PostBackAzioniRnaVariazioneSoggettoBeneficiarioMutationError =
  ErrorType<unknown>;

/**
 * @summary variazioneSoggettoBeneficiario
 */
export const usePostBackAzioniRnaVariazioneSoggettoBeneficiario = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaVariazioneSoggettoBeneficiario>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaVariazioneSoggettoBeneficiarioMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * variazionePuntuale
 * @summary variazionePuntuale
 */
export const postBackAzioniRnaVariazionePuntuale = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/variazionePuntuale`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaVariazionePuntualeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaVariazionePuntuale>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaVariazionePuntuale>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaVariazionePuntuale>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaVariazionePuntuale(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaVariazionePuntualeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaVariazionePuntuale>>
>;
export type PostBackAzioniRnaVariazionePuntualeMutationBody = WorkflowEvent;
export type PostBackAzioniRnaVariazionePuntualeMutationError =
  ErrorType<unknown>;

/**
 * @summary variazionePuntuale
 */
export const usePostBackAzioniRnaVariazionePuntuale = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaVariazionePuntuale>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaVariazionePuntualeMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * variazioneImporto
 * @summary variazioneImporto
 */
export const postBackAzioniRnaVariazioneImporto = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/variazioneImporto`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaVariazioneImportoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaVariazioneImporto>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaVariazioneImporto>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaVariazioneImporto>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaVariazioneImporto(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaVariazioneImportoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaVariazioneImporto>>
>;
export type PostBackAzioniRnaVariazioneImportoMutationBody = WorkflowEvent;
export type PostBackAzioniRnaVariazioneImportoMutationError =
  ErrorType<unknown>;

/**
 * @summary variazioneImporto
 */
export const usePostBackAzioniRnaVariazioneImporto = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaVariazioneImporto>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaVariazioneImportoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * statoRichiesta
 * @summary statoRichiesta
 */
export const postBackAzioniRnaStatoRichiesta = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/statoRichiesta`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaStatoRichiestaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaStatoRichiesta>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaStatoRichiesta>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaStatoRichiesta>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaStatoRichiesta(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaStatoRichiestaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaStatoRichiesta>>
>;
export type PostBackAzioniRnaStatoRichiestaMutationBody = WorkflowEvent;
export type PostBackAzioniRnaStatoRichiestaMutationError = ErrorType<unknown>;

/**
 * @summary statoRichiesta
 */
export const usePostBackAzioniRnaStatoRichiesta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaStatoRichiesta>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaStatoRichiestaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * scaricaVisura
 * @summary scaricaVisura
 */
export const postBackAzioniRnaScaricaVisura = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/scaricaVisura`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaScaricaVisuraMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaVisura>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaScaricaVisura>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaVisura>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaScaricaVisura(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaScaricaVisuraMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaScaricaVisura>>
>;
export type PostBackAzioniRnaScaricaVisuraMutationBody = WorkflowEvent;
export type PostBackAzioniRnaScaricaVisuraMutationError = ErrorType<unknown>;

/**
 * @summary scaricaVisura
 */
export const usePostBackAzioniRnaScaricaVisura = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaVisura>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaScaricaVisuraMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * scaricaVisuraConcessione
 * @summary scaricaVisuraConcessione
 */
export const postBackAzioniRnaScaricaVisuraConcessione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/scaricaVisuraConcessione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaScaricaVisuraConcessioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaVisuraConcessione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaScaricaVisuraConcessione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaVisuraConcessione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaScaricaVisuraConcessione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaScaricaVisuraConcessioneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaVisuraConcessione>>
  >;
export type PostBackAzioniRnaScaricaVisuraConcessioneMutationBody =
  WorkflowEvent;
export type PostBackAzioniRnaScaricaVisuraConcessioneMutationError =
  ErrorType<unknown>;

/**
 * @summary scaricaVisuraConcessione
 */
export const usePostBackAzioniRnaScaricaVisuraConcessione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaVisuraConcessione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaScaricaVisuraConcessioneMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * scaricaEsitoRichiesta
 * @summary scaricaEsitoRichiesta
 */
export const postBackAzioniRnaScaricaEsitoRichiesta = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/scaricaEsitoRichiesta`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaScaricaEsitoRichiestaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaEsitoRichiesta>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaScaricaEsitoRichiesta>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaEsitoRichiesta>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaScaricaEsitoRichiesta(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaScaricaEsitoRichiestaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaScaricaEsitoRichiesta>>
>;
export type PostBackAzioniRnaScaricaEsitoRichiestaMutationBody = WorkflowEvent;
export type PostBackAzioniRnaScaricaEsitoRichiestaMutationError =
  ErrorType<unknown>;

/**
 * @summary scaricaEsitoRichiesta
 */
export const usePostBackAzioniRnaScaricaEsitoRichiesta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaEsitoRichiesta>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaScaricaEsitoRichiestaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * scaricaCertificazione
 * @summary scaricaCertificazione
 */
export const postBackAzioniRnaScaricaCertificazione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/scaricaCertificazione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaScaricaCertificazioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaCertificazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaScaricaCertificazione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaCertificazione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaScaricaCertificazione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaScaricaCertificazioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaScaricaCertificazione>>
>;
export type PostBackAzioniRnaScaricaCertificazioneMutationBody = WorkflowEvent;
export type PostBackAzioniRnaScaricaCertificazioneMutationError =
  ErrorType<unknown>;

/**
 * @summary scaricaCertificazione
 */
export const usePostBackAzioniRnaScaricaCertificazione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaScaricaCertificazione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaScaricaCertificazioneMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * richiediVisure
 * @summary richiediVisure
 */
export const postBackAzioniRnaRichiediVisure = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/richiediVisure`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaRichiediVisureMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisure>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisure>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisure>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaRichiediVisure(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaRichiediVisureMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisure>>
>;
export type PostBackAzioniRnaRichiediVisureMutationBody = WorkflowEvent;
export type PostBackAzioniRnaRichiediVisureMutationError = ErrorType<unknown>;

/**
 * @summary richiediVisure
 */
export const usePostBackAzioniRnaRichiediVisure = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisure>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaRichiediVisureMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * richiediVisureDeminimis
 * @summary richiediVisureDeminimis
 */
export const postBackAzioniRnaRichiediVisureDeminimis = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/richiediVisureDeminimis`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaRichiediVisureDeminimisMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureDeminimis>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureDeminimis>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureDeminimis>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaRichiediVisureDeminimis(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaRichiediVisureDeminimisMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureDeminimis>>
  >;
export type PostBackAzioniRnaRichiediVisureDeminimisMutationBody =
  WorkflowEvent;
export type PostBackAzioniRnaRichiediVisureDeminimisMutationError =
  ErrorType<unknown>;

/**
 * @summary richiediVisureDeminimis
 */
export const usePostBackAzioniRnaRichiediVisureDeminimis = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureDeminimis>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaRichiediVisureDeminimisMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * richiediVisureDeggendorf
 * @summary richiediVisureDeggendorf
 */
export const postBackAzioniRnaRichiediVisureDeggendorf = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/richiediVisureDeggendorf`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaRichiediVisureDeggendorfMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureDeggendorf>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureDeggendorf>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureDeggendorf>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaRichiediVisureDeggendorf(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaRichiediVisureDeggendorfMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureDeggendorf>>
  >;
export type PostBackAzioniRnaRichiediVisureDeggendorfMutationBody =
  WorkflowEvent;
export type PostBackAzioniRnaRichiediVisureDeggendorfMutationError =
  ErrorType<unknown>;

/**
 * @summary richiediVisureDeggendorf
 */
export const usePostBackAzioniRnaRichiediVisureDeggendorf = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureDeggendorf>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaRichiediVisureDeggendorfMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * richiediVisureAiuti
 * @summary richiediVisureAiuti
 */
export const postBackAzioniRnaRichiediVisureAiuti = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/richiediVisureAiuti`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaRichiediVisureAiutiMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureAiuti>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureAiuti>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureAiuti>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaRichiediVisureAiuti(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaRichiediVisureAiutiMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureAiuti>>
>;
export type PostBackAzioniRnaRichiediVisureAiutiMutationBody = WorkflowEvent;
export type PostBackAzioniRnaRichiediVisureAiutiMutationError =
  ErrorType<unknown>;

/**
 * @summary richiediVisureAiuti
 */
export const usePostBackAzioniRnaRichiediVisureAiuti = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaRichiediVisureAiuti>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaRichiediVisureAiutiMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * reiteraRegistraAiuto
 * @summary reiteraRegistraAiuto
 */
export const postBackAzioniRnaReiteraRegistraAiuto = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/reiteraRegistraAiuto`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaReiteraRegistraAiutoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaReiteraRegistraAiuto>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaReiteraRegistraAiuto>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaReiteraRegistraAiuto>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaReiteraRegistraAiuto(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaReiteraRegistraAiutoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaReiteraRegistraAiuto>>
>;
export type PostBackAzioniRnaReiteraRegistraAiutoMutationBody = WorkflowEvent;
export type PostBackAzioniRnaReiteraRegistraAiutoMutationError =
  ErrorType<unknown>;

/**
 * @summary reiteraRegistraAiuto
 */
export const usePostBackAzioniRnaReiteraRegistraAiuto = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaReiteraRegistraAiuto>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaReiteraRegistraAiutoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * registraAiuto
 * @summary registraAiuto
 */
export const postBackAzioniRnaRegistraAiuto = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/registraAiuto`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaRegistraAiutoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaRegistraAiuto>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaRegistraAiuto>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaRegistraAiuto>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaRegistraAiuto(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaRegistraAiutoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaRegistraAiuto>>
>;
export type PostBackAzioniRnaRegistraAiutoMutationBody = WorkflowEvent;
export type PostBackAzioniRnaRegistraAiutoMutationError = ErrorType<unknown>;

/**
 * @summary registraAiuto
 */
export const usePostBackAzioniRnaRegistraAiuto = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaRegistraAiuto>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaRegistraAiutoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * recuperaIdRichiesta
 * @summary recuperaIdRichiesta
 */
export const postBackAzioniRnaRecuperaIdRichiesta = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/recuperaIdRichiesta`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaRecuperaIdRichiestaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaRecuperaIdRichiesta>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaRecuperaIdRichiesta>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaRecuperaIdRichiesta>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaRecuperaIdRichiesta(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaRecuperaIdRichiestaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaRecuperaIdRichiesta>>
>;
export type PostBackAzioniRnaRecuperaIdRichiestaMutationBody = WorkflowEvent;
export type PostBackAzioniRnaRecuperaIdRichiestaMutationError =
  ErrorType<unknown>;

/**
 * @summary recuperaIdRichiesta
 */
export const usePostBackAzioniRnaRecuperaIdRichiesta = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaRecuperaIdRichiesta>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaRecuperaIdRichiestaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * modificaAttoConcessione
 * @summary modificaAttoConcessione
 */
export const postBackAzioniRnaModificaAttoConcessione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/modificaAttoConcessione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaModificaAttoConcessioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaModificaAttoConcessione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaModificaAttoConcessione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaModificaAttoConcessione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaModificaAttoConcessione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaModificaAttoConcessioneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniRnaModificaAttoConcessione>>
  >;
export type PostBackAzioniRnaModificaAttoConcessioneMutationBody =
  WorkflowEvent;
export type PostBackAzioniRnaModificaAttoConcessioneMutationError =
  ErrorType<unknown>;

/**
 * @summary modificaAttoConcessione
 */
export const usePostBackAzioniRnaModificaAttoConcessione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaModificaAttoConcessione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaModificaAttoConcessioneMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * confermaVariazioneConcessione
 * @summary confermaVariazioneConcessione
 */
export const postBackAzioniRnaConfermaVariazioneConcessione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/confermaVariazioneConcessione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaConfermaVariazioneConcessioneMutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postBackAzioniRnaConfermaVariazioneConcessione>
      >,
      TError,
      { data: WorkflowEvent },
      TContext
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaConfermaVariazioneConcessione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  > => {
    const { mutation: mutationOptions, request: requestOptions } =
      options ?? {};

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postBackAzioniRnaConfermaVariazioneConcessione>
      >,
      { data: WorkflowEvent }
    > = props => {
      const { data } = props ?? {};

      return postBackAzioniRnaConfermaVariazioneConcessione(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostBackAzioniRnaConfermaVariazioneConcessioneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniRnaConfermaVariazioneConcessione>>
  >;
export type PostBackAzioniRnaConfermaVariazioneConcessioneMutationBody =
  WorkflowEvent;
export type PostBackAzioniRnaConfermaVariazioneConcessioneMutationError =
  ErrorType<unknown>;

/**
 * @summary confermaVariazioneConcessione
 */
export const usePostBackAzioniRnaConfermaVariazioneConcessione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaConfermaVariazioneConcessione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaConfermaVariazioneConcessioneMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * confermaConcessione
 * @summary confermaConcessione
 */
export const postBackAzioniRnaConfermaConcessione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/confermaConcessione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaConfermaConcessioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaConfermaConcessione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaConfermaConcessione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaConfermaConcessione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaConfermaConcessione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaConfermaConcessioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaConfermaConcessione>>
>;
export type PostBackAzioniRnaConfermaConcessioneMutationBody = WorkflowEvent;
export type PostBackAzioniRnaConfermaConcessioneMutationError =
  ErrorType<unknown>;

/**
 * @summary confermaConcessione
 */
export const usePostBackAzioniRnaConfermaConcessione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaConfermaConcessione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaConfermaConcessioneMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * annullaVariazioneConcessione
 * @summary annullaVariazioneConcessione
 */
export const postBackAzioniRnaAnnullaVariazioneConcessione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/annullaVariazioneConcessione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaAnnullaVariazioneConcessioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaAnnullaVariazioneConcessione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaAnnullaVariazioneConcessione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaAnnullaVariazioneConcessione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaAnnullaVariazioneConcessione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaAnnullaVariazioneConcessioneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniRnaAnnullaVariazioneConcessione>>
  >;
export type PostBackAzioniRnaAnnullaVariazioneConcessioneMutationBody =
  WorkflowEvent;
export type PostBackAzioniRnaAnnullaVariazioneConcessioneMutationError =
  ErrorType<unknown>;

/**
 * @summary annullaVariazioneConcessione
 */
export const usePostBackAzioniRnaAnnullaVariazioneConcessione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaAnnullaVariazioneConcessione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaAnnullaVariazioneConcessioneMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * annullaConcessione
 * @summary annullaConcessione
 */
export const postBackAzioniRnaAnnullaConcessione = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/rna/annullaConcessione`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniRnaAnnullaConcessioneMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaAnnullaConcessione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniRnaAnnullaConcessione>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniRnaAnnullaConcessione>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniRnaAnnullaConcessione(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniRnaAnnullaConcessioneMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniRnaAnnullaConcessione>>
>;
export type PostBackAzioniRnaAnnullaConcessioneMutationBody = WorkflowEvent;
export type PostBackAzioniRnaAnnullaConcessioneMutationError =
  ErrorType<unknown>;

/**
 * @summary annullaConcessione
 */
export const usePostBackAzioniRnaAnnullaConcessione = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniRnaAnnullaConcessione>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniRnaAnnullaConcessioneMutationOptions(options);

  return useMutation(mutationOptions);
};
